import React, { useCallback, useState } from "react";
import { Button } from "@material-ui/core";
import { Refresh as RefreshIcon } from "@material-ui/icons";
import { ConfirmDialog } from "src/apps/commons/dataDisplays";
import useApiAlert from "src/hooks/useApiAlert";
import useHttpErrorHandler from "src/hooks/useHttpErrorHandler";
import * as Api from "../api";

const ReloadServerCacheButton = () => {
  const { setMessage } = useApiAlert();
  const { handleError } = useHttpErrorHandler();

  const [fetching, setFetching] = useState(false);
  const [confirmDialogState, setConfirmDialogState] = useState<{
    open: boolean;
    onConfirm?: () => void;
  }>({ open: false });

  const handleCloseDialog = useCallback(() => {
    setConfirmDialogState({ open: false, onConfirm: undefined });
  }, []);
  const handleClick = useCallback(() => {
    if (!fetching) {
      setConfirmDialogState({
        open: true,
        onConfirm: async () => {
          setFetching(true);
          try {
            await Api.reloadRemyndMasterCache();
            setFetching(false);
            setMessage("success", "Reload server cache success");
          } catch (e) {
            handleError(e);
            setFetching(false);
          }
          handleCloseDialog();
        }
      });
    }
  }, [fetching, handleError, setMessage, handleCloseDialog]);

  return (
    <>
      <Button
        variant="text"
        type="button"
        size="small"
        startIcon={<RefreshIcon />}
        onClick={handleClick}
      >
        Reload Server Cache
      </Button>
      <ConfirmDialog
        title="Reload Server Cache?"
        description={`ข้อมูล Remynd Master สำหรับฝั่ง Mobile เรียกใช้จะมีการ cache ไว้
หากมีแก้ข้อมูลตรงใน database แล้วต้องการอัพเเดต cache ทันที ให้กดปุ่มนี้
(ปกติมีอัพเดตอัตโนมัติทุก 1 ชั่วโมง และทุกครั้งที่แก้ผ่านหน้าจอ)`}
        open={confirmDialogState.open}
        onClose={handleCloseDialog}
        onConfirm={confirmDialogState.onConfirm}
        confirming={fetching}
      />
    </>
  );
};

export default ReloadServerCacheButton;
